export const SETUSER = 'SETUSER';
export const SETSKILLS = 'SETSKILLS'